module.exports = __webpack_public_path__ + "static/media/3.f8b4901c.jpg";